import { rem } from '@Utils/styles';
import styled from 'styled-components';

export const SensorPropertiesWrapper = styled.div`
	.MuiSkeleton-text {
		max-width: ${rem(200)};
	}
`;
